/* lua.js generated code 0.3.0 */

/* 
Copyright (c) 2011-2014 chukong-inc.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

 */
var TextField = ccui.TextField
TextField.prototype.onEvent = function (callback) {
    var self = this
    self.addEventListener(function (sender, eventType) {
        var event = table()
        event.eventType = eventType
        if (eventType === 0) {
            event.name = "ATTACH_WITH_IME"
        } else if (eventType === 1) {
            event.name = "DETACH_WITH_IME"
        } else if (eventType === 2) {
            event.name = "INSERT_TEXT"
        } else if (eventType === 3) {
            event.name = "DELETE_BACKWARD"
        }
        event.target = sender
        if (callback) {
            callback(event)
        }
        if (self.__focusEvent && type(self.__focusEvent) === "function") {
            self.__focusEvent(event)
        }
    })
    return self
}
TextField.prototype.extendFocus = function () {
    var self = this
    function onFocus(event) {
        if (event.eventType === 0) {
            self.__focusIn()
        } else if (event.eventType === 1) {
            self.__focusOut()
        } else if (event.eventType === 2) {
            self.__refreshCursor()
        } else if (event.eventType === 3) {
            self.__refreshCursor()
        }
    }
    self.__focusEvent = onFocus
    self.__initCursorSprite("editor/cursor.png")
    self.setFontName("msyhbd")
    return self
}
TextField.prototype.__initCursorSprite = function (imageName) {
    var self = this
    self.cursor = cc.Sprite.create(imageName)
    self.cursor.setAnchorPoint(cc.p(0, 0))
    self.addChild(self.cursor)
    var sequence = transition.sequence(table([0, cc.FadeOut.create(0.3)], [0, cc.FadeIn.create(0.3)]))
    var foreverAction = cc.RepeatForever.create(sequence)
    self.cursor.runAction(foreverAction)
    self.cursor.setVisible(false)
}
TextField.prototype.__focusIn = function () {
    var self = this
    self.cursor.setVisible(true)
    self.__refreshCursor()
}
TextField.prototype.__refreshCursor = function () {
    var self = this
    var str = self.getString()
    var w = $len(str) * self.getFontSize() * 0.5
    self.cursor.setPosition(cc.p(w, 0))
}
TextField.prototype.__focusOut = function () {
    var self = this
    self.cursor.setVisible(false)
}
